export default __webpack_public_path__ + "static/media/brown-plus.a57f8efb.svg";